import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    if (document.body?.dataset?.testEnv === 'true') return

    setTimeout(() => {
      this.element.classList.add('pull-up')
      setTimeout(() => {
        this.element.remove()
      }, 1900)
    }, 2000)
  }

  dismiss() {
    this.element.remove()
  }
}
